import React, { CSSProperties, PropsWithChildren } from 'react';
import { StyledHeading } from './styled';

export type Variant = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export type HeadingProps = PropsWithChildren<{
  variant?: Variant;
  span?: boolean;
  faded?: boolean;
  style?: CSSProperties;
  emoji?: string;
}>;

export function Heading({
  children,
  variant = 'h1',
  span = false,
  faded = false,
  style,
  ...props
}: HeadingProps): JSX.Element {
  return (
    <StyledHeading
      as={span ? 'span' : variant}
      variant={variant}
      faded={faded}
      style={style}
      {...props}
    >
      {children}
    </StyledHeading>
  );
}
